import { render, staticRenderFns } from "./cms-navigation.vue?vue&type=template&id=43df131f&scoped=true&"
import script from "./cms-navigation.vue?vue&type=script&lang=js&"
export * from "./cms-navigation.vue?vue&type=script&lang=js&"
import style0 from "./cms-navigation.vue?vue&type=style&index=0&id=43df131f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43df131f",
  null
  
)

export default component.exports